import PartnerListOverview from './PartnerListOverview';

export default PartnerListOverview;
